"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _utils = require("../utils");

var _DOM = _interopRequireDefault(require("../display/DOM"));

var _globals = require("../globals");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ActivityIndicator =
/** @class */
function () {
  function ActivityIndicator(opts) {
    if (opts === void 0) {
      opts = null;
    }

    this._opts = (0, _utils.extend)({
      strokeWidth: 4
    }, opts);
    this.render();
  }

  Object.defineProperty(ActivityIndicator.prototype, "$el", {
    get: function () {
      return this._target;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(ActivityIndicator.prototype, "$path", {
    get: function () {
      return (0, _DOM.default)("." + _globals.Globals.cssPrefix + "fill-path", this.$el);
    },
    enumerable: false,
    configurable: true
  });

  ActivityIndicator.prototype.appendTo = function (target, styles) {
    if (styles === void 0) {
      styles = null;
    }

    var $target = (0, _DOM.default)(target);

    if ($target.length > 0) {
      $target.append(this.$el);
      this._target = (0, _DOM.default)("." + _globals.Globals.cssPrefix + "loader", $target);

      if (styles) {
        this._target.css(styles);
      }
    }
  };

  ActivityIndicator.prototype.startAnimating = function () {
    this.$el.addClass('animated');
  };

  ActivityIndicator.prototype.stopAnimating = function () {
    this.$el.removeClass('animated');
  };

  ActivityIndicator.prototype.render = function () {
    var isPercentage = false;
    var size = (0, _utils.get)(this._opts, 'size') || '100%';

    if ((0, _utils.isString)(size)) {
      if (/%$/.test(size) === false) {
        size = size.replace(/[0-9\.]/, '');
        size = parseFloat(size);
      } else {
        isPercentage = true;
      }
    }

    var s = (0, _utils.isString)(size) ? 60 : size;
    var center = Math.round(s / 2);
    var radius = Math.round(18 * (s / 60));
    var offset = Math.round(s / 2);
    var stroke = (0, _utils.get)(this._opts, 'strokeWidth') || 4;
    var sizeStr = isPercentage ? size : size + "px";
    this._target = (0, _DOM.default)("\n\t\t\t<div class=\"" + _globals.Globals.cssPrefix + "loader\" style=\"width: " + sizeStr + "; height: " + sizeStr + ";\">\n\t\t\t\t<svg version=\"1.1\" class=\"" + _globals.Globals.cssPrefix + "filler-loader\" width=\"" + s + "\" height=\"" + s + "\" style=\"margin-top: -" + offset + "px; margin-left: -" + offset + "px;\">\n\t\t\t\t\t<circle class=\"" + _globals.Globals.cssPrefix + "fill-path\" cx=\"" + center + "\" cy=\"" + center + "\" r=\"" + radius + "\" stroke-width=\"" + stroke + "\" />\n\t\t\t\t</svg>\n\t\t\t</div>\n\t\t");
  };

  return ActivityIndicator;
}();

var _default = ActivityIndicator;
exports.default = _default;
module.exports = exports.default;